import { AlertTriangle } from 'lucide-react';
import { useBackdropClose } from '../utils/backdropClose';

// Shared confirm dialog for destructive / status-changing owner actions
// (open/close registration, etc.). Parity between Tournaments & Open Play.
// `input` (optional): { value, onChange, placeholder, minLength } renders a field above the
// buttons and holds Confirm until it is filled — for actions that ask the owner's key.
// `hideConfirm`: the choices live inside `message` (a picker) — show only Cancel.
export const ConfirmModal = ({ title, message, confirmLabel = 'Confirm', color = '#E63946', onConfirm, onCancel, input = null, hideConfirm = false }) => {
  const backdrop = useBackdropClose(onCancel);
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center p-4" style={{ background: 'rgba(0,0,0,0.85)' }} {...backdrop}>
      <div data-testid="confirm-modal" className="w-full max-w-sm rounded-2xl p-5" style={{ background: '#0F0F0F', border: '1px solid #2A2A2A' }} onClick={e => e.stopPropagation()}>
        <div className="flex items-center gap-2 mb-2">
          <AlertTriangle className="h-5 w-5 shrink-0" style={{ color }} />
          <h3 className="text-base font-bold uppercase" style={{ fontFamily: 'Oswald, sans-serif', color: '#fff' }}>{title}</h3>
        </div>
        <p className="text-sm mb-5" style={{ color: '#A3A3A3', lineHeight: 1.5 }}>{message}</p>
        {input && (
          <input data-testid="confirm-input" value={input.value} onChange={e => input.onChange(e.target.value)} placeholder={input.placeholder || ''}
            inputMode="numeric" type="password" autoComplete="one-time-code" autoFocus
            onKeyDown={e => { if (e.key === 'Enter' && input.value.length >= (input.minLength || 4)) onConfirm(); }}
            style={{ background: '#0A0A0A', border: '1px solid #2A2A2A', color: '#fff', borderRadius: 8, padding: '9px 12px', width: '100%', outline: 'none', fontSize: 14, letterSpacing: 3, marginBottom: 16 }} />
        )}
        <div className="flex gap-2 justify-end">
          <button data-testid="confirm-cancel" onClick={onCancel}
            className="px-4 py-2 rounded-lg text-xs font-bold"
            style={{ background: '#1A1A1A', color: '#A3A3A3', border: '1px solid #2A2A2A' }}>
            Cancel
          </button>
          {!hideConfirm && (
            <button data-testid="confirm-ok" onClick={onConfirm} disabled={!!input && input.value.length < (input.minLength || 4)}
              className="px-4 py-2 rounded-lg text-xs font-bold uppercase"
              style={{ background: color, color: '#fff' }}>
              {confirmLabel}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
